import { MasterApiClient, UserAuthClient } from './httpClient';

const USER_SETTING_BASE_PATH = 'userSettings';

export const fetchUserSettings = async () => {
  const response = await MasterApiClient.get(USER_SETTING_BASE_PATH, {}, true);
  return response;
};

export const saveUserTheme = async (darkMode) => {
  const response = await MasterApiClient.put(
    `${USER_SETTING_BASE_PATH}/theme`,
    {
      darkMode,
    }
  );
  return response;
};

export const saveUserLanguage = async (languageCode) => {
  const response = await MasterApiClient.put(
    `${USER_SETTING_BASE_PATH}/userLang`,
    {
      DefaultLanguage: languageCode,
    }
  );
  return response;
};

export const saveUserPerformanceCookiePreference = async (
  allowPerformanceCookies
) => {
  const response = await MasterApiClient.put(
    `${USER_SETTING_BASE_PATH}/allowPerformanceCookies`,
    {
      allowPerformanceCookies,
    }
  );
  return response;
};

export const setDoNotProcessForPendo = async (doNotProcessRequests) => {
  const response = await UserAuthClient.put('users/doNotProcessPendoRequests', {
    doNotProcessRequests,
  });
  return response;
};
